import React from 'react'
import { ContentWarning } from './ContentWarning.d'

const ContentWarningModule = ({ text }: ContentWarning) => {
  return (
    <p className='otl-content-warning mt-8 text-default font-serif'>
      <em>{text.text}</em>
    </p>
  )
}

export default ContentWarningModule
